import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { AppRoutingModule } from '../app-routing.module';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { NotFoundComponent } from './not-found/not-found.component';

@NgModule({
  declarations: [NotAuthorizedComponent, UnderConstructionComponent, NotFoundComponent],
  imports: [ CommonModule, AppRoutingModule ]
})
export class ErrorsModule { }
